(function () {
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('.coltabs__toggle');
    if (toggle) {
      var root = toggle.closest('.coltabs');
      var open = root.classList.toggle('coltabs--open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      e.stopPropagation();
      return;
    }
    // click outside → close any open dropdown
    document.querySelectorAll('.coltabs.coltabs--open').forEach(function (root) {
      if (!root.contains(e.target)) {
        root.classList.remove('coltabs--open');
        var t = root.querySelector('.coltabs__toggle');
        if (t) t.setAttribute('aria-expanded', 'false');
      }
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.coltabs.coltabs--open').forEach(function (root) {
        root.classList.remove('coltabs--open');
        var t = root.querySelector('.coltabs__toggle');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }
  });
})();
